class ScreenContrast{
  cssValueToPx(value, rem = 1) {
    if(/px$/.test(value)){
      return parseFloat(value);
    }

    if(/vw$/.test(value)){
      const vw = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
      return parseFloat(value) * vw / 100;
    }

    if(/rem$/.test(value)){
      return parseFloat(value) * rem;
    }
  }

  constructor(darkScreens=[]) {
    this.darkScreens = darkScreens;
    document.addEventListener('scroll', () => this.onScreenUpdate())
    window.addEventListener('resize', ()=> this.onScreenUpdate());
    this.onScreenUpdate();
  }

  checkVisible(element, threshold) {
    const rect = element.getBoundingClientRect();
    if(rect.bottom < threshold)return false;
    return rect.top < threshold;
  }

  getOnScreenElement(nodeList, threshold){
    for(let i = 0; i < nodeList.length; i++){
      const element = nodeList.item(i);
      if(this.checkVisible(element, threshold))return element;
    }
  }

  onScreenUpdate(){
    const computedStyle = getComputedStyle(document.documentElement);
    const rem = this.cssValueToPx(computedStyle.getPropertyValue('--rem'));
    const hh  = this.cssValueToPx(computedStyle.getPropertyValue('--hh'), rem);

    this.getOnScreenElement(this.darkScreens, hh) ? this.onDark('top') : this.onBright('top');
    this.getOnScreenElement(this.darkScreens, window.innerHeight * 0.5) ? this.onDark('middle') : this.onBright('middle');
    this.getOnScreenElement(this.darkScreens, Math.min(window.innerHeight * 0.9, window.innerHeight - hh)) ? this.onDark('bottom') : this.onBright('bottom');
  }

  onDark(pos){
    if(document.body.classList.contains(`on-${pos}-bright`))document.body.classList.remove(`on-${pos}-bright`);
    if(document.body.classList.contains(`on-${pos}-dark`))return;
    document.body.classList.add(`on-${pos}-dark`);
  }

  onBright(pos){
    if(document.body.classList.contains(`on-${pos}-dark`))document.body.classList.remove(`on-${pos}-dark`);
    if(document.body.classList.contains(`on-${pos}-bright`))return;
    document.body.classList.add(`on-${pos}-bright`);
  }
}

export {ScreenContrast}